import React from 'react';

interface Props {
  disabled?: boolean;
  title: string;
  isLoading?: boolean;
  id?: string;
  type?: 'button' | 'reset' | 'submit' | undefined;
  layout?: 'primary-green' | 'secondary';
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export const Button: React.FC<Props> = ({
  isLoading,
  disabled,
  layout = 'primary-green',
  title,
  type,
  id,
  className,
  onClick = null,
}) => {
  const handleOnClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    // Only perform onClick if the button isn't disabled or is loading
    if (!disabled && !isLoading && onClick) {
      onClick(event);
    }
  };

  const getButtonClass = () => {
    switch (layout) {
      case 'primary-green':
        return 'btn btn--primary-green';
      case 'secondary':
        return 'btn btn--secondary';
    }
  };

  if (isLoading) {
    return (
      <button
        id={id}
        type={type}
        onClick={handleOnClick}
        className={`${getButtonClass()} ${className} inline-flex gap-3xs`}
        disabled={true}
      >
        <div className="circle-loader circle-loader--button" role="alert">
          <div aria-hidden="true">
            <div className="circle-loader__circle"></div>
          </div>
        </div>
      </button>
    );
  }

  return (
    <button
      type={type}
      id={id}
      onClick={handleOnClick}
      className={`button ${getButtonClass()} ${className}`}
      disabled={disabled}
    >
      {title}
    </button>
  );
};

Button.defaultProps = {
  disabled: false,
  type: 'button',
  isLoading: false,
};
